/* Copyright 2021, Milkdown by Mirone. */
import { ctxCallOutOfScope } from '@milkdown/exception';
import { shallowClone } from '../utility';
export const createSlice = (value, name) => {
    const id = Symbol('Context');
    const factory = (container, resetValue = shallowClone(value)) => {
        let inner = resetValue;
        const context = {
            id,
            set: (next) => {
                inner = next;
            },
            get: () => inner,
            update: (updater) => {
                inner = updater(inner);
            },
        };
        container.set(id, context);
        return context;
    };
    factory.sliceName = name;
    factory.id = id;
    factory._typeInfo = () => {
        throw ctxCallOutOfScope();
    };
    return factory;
};
//# sourceMappingURL=slice.js.map